export function formatDiscount(discount: number): string {
  return `−${discount}%`;
}
